import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import { Role } from "../../../Shared-ui/Types/common";
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };


interface MyComponentProps {
  changePermission: (event: React.ChangeEvent<HTMLInputElement>) => void
  data: Role
}

const PermissionsTableFlex: React.FC<MyComponentProps> = (props) => {
  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>

      {/* Header */}
      <Box sx={{ display: "flex", pb: 1, fontWeight: "bold", fontSize: "14px" }}>
        <Box sx={{ flex: 3, textAlign: "left" }}>Type</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}>View</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}>Create</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}>Edit</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}>Delete</Box>
      </Box>

      {/* Rows */}

      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>ApiKey</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewApiKeyList" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewApiKeyList} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createApiKey" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.createApiKey} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="editApiKey" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteApiKey" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deleteApiKey} /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Agent</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewAgents" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewAgents} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createAgent" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.createAgent} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="editAgent" disabled /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteAgent" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deleteAgent} /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>All Agents</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewAllAgents" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewAllAgents} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="createAllAgent" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="modifyAllAgents" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.modifyAllAgents} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="deleteAllAgent" /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Agent Files</Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="viewAgentFile" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="uploadAgentFiles" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.uploadAgentFiles} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="editAgentFile" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteAgentFiles" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deleteAgentFiles} /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Group</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewGroup" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewGroup} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createGroup" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.createGroup} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="editGroup" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteGroup" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deleteGroup} /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Prompt</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewPrompt" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewPrompt} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createPrompt" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.createPrompt} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="editPrompt" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deletePrompt" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deletePrompt} /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Template</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewTemplate" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewTemplate} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createTemplate" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.createTemplate} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="editTemplate" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteTemplate" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deleteTemplate} /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Role</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewRole" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewRole} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createRole" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.createRole} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="updateRole" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.updateRole} /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteRole" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deleteRole} /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>User</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewUser" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewUser} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createUser" disabled /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="updateUser" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.updateUser} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteUser" disabled /></Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>New User</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewNewUser" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewNewUser} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="" disabled /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="" disabled /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="" disabled /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Chat Log</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewChatLog" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewChatLog} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="createChatLog" disabled /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="editChatLog" disabled /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteChatLog" disabled /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Dashboard</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewDashboard" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewDashboard} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled /></Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Audit Logs</Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="viewAuditLogs" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.viewAuditLogs} /></Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="createAuditLogs" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="editAuditLogs" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="deleteAuditLogs" /></Box>
      </Box>
      {/* client details page not available in new design */}
      {/* <Box
          sx={{ 
            display: "flex", 
            py: 1, 
            borderTop: "1px solid #ddd",
            fontSize:"14px"
          }}
        >
          <Box sx={{ flex: 3, textAlign: "left" }}>Client Details</Box>
          <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{p:0}} {...label} name="viewClientDetails"/></Box>
          <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{p:0}} {...label} disabled name="createClientDetails"/></Box>
          <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{p:0}} {...label} disabled name="editClientDetails"/></Box>
          <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{p:0}} {...label} name="deleteClientDetails"/></Box>
        </Box> */}
      <Box
        sx={{
          display: "flex",
          py: 1,
          borderTop: "1px solid #ddd",
          fontSize: "14px"
        }}
      >
        <Box sx={{ flex: 3, textAlign: "left" }}>Chat History</Box>
        {/*  missing from old */}
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="viewChatHistory" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="createChatHistory" /></Box>
        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} disabled name="editChatHistory" /></Box>

        <Box sx={{ flex: 1, textAlign: "center" }}><Checkbox sx={{ p: 0 }} {...label} name="deleteChatHistory" onChange={(e) => props.changePermission(e)} checked={props.data.permissions.deleteChatHistory} /></Box>
      </Box>



    </Box>
  );
};

export default PermissionsTableFlex;
